<template>
    <div :class="`header-contain ${className}`" v-if="compID && compID !== 0">
      <div
        class="contain-top"
        :style="{ 'background-image': `url(${compMainBanner})` }"
      >
        <div class="mask"></div>
        
        <div class="com-data-view">
          <div class="com-logo" @click="goCompDetail">
            <comp-icon class="comp-logo" :src="compDetail.CompLogo" :width="116" :height="70"></comp-icon>
          </div>
          <div class="com-data">
            <p class="com-name" @click="goCompDetail">
              {{compDetail.CompName}}
            </p>
            <p class="com-desc text-clamp2">{{compDetail.MainProduct}}</p>
          </div>
        </div>
        <div class="com-data-right">
          <vip-level :iconType="1" :curData="compDetail"></vip-level>
          <div class="call-com">
            <customer-list :compID="compID" :phone="compDetail.Phone"></customer-list>
            <div v-if="isClient || isInIframe" class="call-btn" :class="isExist ? 'active' : ''" @click.stop="enterpriseShow">
              <i class="el-icon el-icon-star-off"></i>
              <span>{{isExist ? '已添加供应链' : '添加到供应链'}}</span>
            </div>
            <div class="call-btn" @click.stop="isClient ? shareCompany() : copy()" v-if="showShare">
              <i class="el-icon el-icon-share"></i>
              <span>{{isClient ? '站内' : ''}}分享</span>
            </div>
          </div>
  
          <div class="data-count">
            <div class="count-view" title="企业通号" v-if="compDetail.compMdt">
              企业通号：
              {{compDetail.compMdt}}
            </div>
            <div class="count-view" title="总浏览次数"><i class="el-icon-view"></i>{{totalBrowse}}</div>
            <div class="count-view" title="总下载次数"><i class="el-icon-download"></i>{{totalDownload}}</div>
          </div>
  
        </div>

        <product-qrcode v-if="compDetail.compId" :compID="compDetail.compId" :compLogo="compDetail.compLogo"></product-qrcode>
  
      </div>
  
      <div class="contain-btm">
        <el-tabs v-model="activeData">
          <el-tab-pane :name="item.key" v-for="item in filterTabs" :key="item.key">
            <template #label><router-link class="m-tab-label" :to="`${item.url}${compID}`">{{item.name}}</router-link></template>
          </el-tab-pane>
        </el-tabs>
        <el-input
          v-model="searchKeyword"
          placeholder="搜索该供应商的产品"
          class="input-with-select"
          @change="goCompanySearch"
        >
          <template #append>
            <el-button icon="el-icon-search" @click="goCompanySearch"></el-button>
          </template>
        </el-input>
      </div>
  
      <dir-selector
        ref="dirSelector"
        categoryType="EnterpriseDir"
        @ensure="enterpriseInsert"
      ></dir-selector>
  
    </div>
  </template>
  
  <script>
  import { Message } from 'element-ui'
  import {CheckLibs} from '@digital-supply-chain/module'
  import copy from "copy-to-clipboard";
  import { CompService, OpenService, AuthService, ApiService, UserService } from '@/service'
  import { Category } from '@/libs'
  
  import CompIcon from '@/components/icon/comp-icon.vue';
  import CustomerList from './customer.vue';
  import ProductQrcode from './product-qrcode.vue'
  import DirSelector from '@/components/dir-selector/index.vue'
  import VipLevel from "@/components/icon/vip-level.vue";
  
  export default {
    components: { CompIcon, CustomerList, DirSelector, VipLevel, ProductQrcode },
    props: {
      compID: { default: 0 },
      activeKey: { default: '' },
      className: { default: '' },
    },
    data() {
      return {
        searchKeyword: '',
        tabs: [
          { key: 'lbj', name: '产品中心', url: '/product/list/' },
          { key: 'flxx', name: '分类选型', url: '/company/lecto/' },
          { key: 'lxwm', name: '联系我们', url: '/company/contact/' },
          { key: 'gywm', name: '关于我们', url: '/company/about/' },
        ],
        compDetail: {},
        isExist: false,
        activeData: this.activeKey === 'prod' ? 'lbj' : this.activeKey,
  
        ApiService,
        OpenService,
  
        totalBrowse: 0,
        totalDownload: 0,
  
        isClient: CheckLibs.isClient(),
        isInIframe: CheckLibs.isInIframe(),
        compMainBanner: '',
      }
    },
    computed: {
      showShare() {
        if (this.isInIframe) return false;
        return true;
      },
      // compMainBanner() {
      //   return CompService.getCompMainBanner(this.compID);
      // },
      filterTabs() {
        return this.tabs.filter(item => {
          if (item.key === 'flxx') {
            return AuthService.getLectoByCompid(this.compID);
          }
          return true;
        })
      },
    },
    mounted() {
      this.getCompInfo();
      this.enterpriseExist();
      this.getDataBriefingt();
  
      this.activeKey !== 'prod' && (UserService.viewLogs('Comp', this.compID));
    },
    methods: {
      async getDataBriefingt() {
        const res = await CompService.getDataBriefingt(this.compID);
        if (res.code === 0) {
          const {totalBrowse, totalDownload} = res.data;
          this.totalBrowse = totalBrowse;
          this.totalDownload = totalDownload;
        }
      },
  
      async goCompanySearch() {
        if (!this.searchKeyword) return;
        OpenService.openSearchLib(this.searchKeyword, true, `?compId=${this.compID}&compName=${this.compDetail.CompName}`)
      },
  
      goCompDetail() {
        OpenService.openCompDetail(this.compID);
      },
  
      async getCompInfo() {
        const res = await CompService.getCompanyInfo(this.compID);
        if (res.code === 0) {
          this.compDetail = res.data;
          this.compMainBanner =`${ApiService.ImageHost}${res.data.CompanyBanner}`;
          if (!location.pathname.includes('/product/detail')) {
            document.title = this.$route.meta.title + '-' + res.data.CompName;
          }

          // const status = (res.data.info && res.data.info.status === 0) ? 0 : 1;
          // if (status == 0) {
          //     window.location.replace(`${location.origin}/exception/vipexpire/${this.compID}`)
          //     return false;
          // }

          const compState = Number(res.data.state);
          if (compState == 9) {
              window.location.replace(`${location.origin}/exception/vipexpire/${this.compID}`)
              return false;
          }

          this.$emit('returnCompInfo', res.data);
        }
      },
      enterpriseShow() {
        if (this.isExist) return;
        this.$refs.dirSelector.show();
      },
      async enterpriseInsert(currentNode) {
        if (this.isExist) return;
        const res = await CompService.enterpriseInsert(
          currentNode.DirID,
          currentNode.CategoryID || Category.EnterpriseDir,
          this.compID,
          this.compDetail.Remark,
          this.compDetail.CompName,
        );
        this.enterpriseExist();
        if (res) {
          Message({
            message: '供应商添加成功',
            type: 'success',
          })
        }
      },
      async enterpriseExist() {
        let res = null;
        try {
          res = await CompService.enterpriseExist(this.compID, true);
        } catch (error) {}
        res && (this.isExist = res ? true : false);
      },
  
      // 企业站内分享
      shareCompany() {
        const desc = this.compDetail.MainProduct;
        const prodName = this.compDetail.CompName || '';
        const data = encodeURI('<m_link,'+ encodeURIComponent(location.href) +','+ encodeURIComponent(prodName) +', ' + encodeURIComponent(desc) +',>') ;
        OpenService.openShareBiz(data);
      },
      copy() {
        if (copy(location.href)) {
          Message.success("复制成功，可以转发给好友了");
        } else {
          Message.error("复制失败");
        }
      },
    }
  }
  </script>
  
  <style lang="less" scoped>
  .data-count{
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
    .count-view{
      color: #ffffff;
      display: flex;
      align-items: center;
      font-size: 13px;
      line-height: 20px;
      margin-left: 18px;
      // text-align: center;
      // width: 150px;
      // justify-content: center;
    }
    i{
      font-size: 20px;
      margin-right: 6px;
    }
  }
  
  // tabs部分
  .contain-btm{
    height: 47px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border: 1px solid var(--el-border-color-light);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
    /deep/ .el-input-group{
      width: 400px;
      height: 36px;
    }
    /deep/ .el-input__inner{
      height: 36px;
      border-top-left-radius: 18px;
      border-bottom-left-radius: 18px;
    }
    /deep/ .el-input-group__append{
      border-top-right-radius: 18px;
      border-bottom-right-radius: 18px;
    }
    /deep/ .el-tabs__header{
      margin: 0;
    }
    /deep/ .el-tabs__item{
      height: 47px;
      line-height: 47px;
    }
    /deep/ .el-tabs__nav-wrap::after{
      height: 1px;
    }
    /deep/ .el-tabs__active-bar{
      background: linear-gradient(90deg, #0A89C5 0%, #995CB6 100%);
      transition: none;
    }
  }
  .m-tab-label{
    color: @text-color-base;
    text-decoration: none;
    display: block;
  }
  /deep/ .el-tabs__item.is-active{
    .m-tab-label{
      color: #0989C5;
      background: linear-gradient(90deg, #0A89C5 0%, #995CB6 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  
  .header-contain{
    margin-bottom: 12px;
    position: sticky;
    z-index: 9;
    top: -146px;
  }
  .contain-top{
    height: 130px;
    background-position: center center;
    background-size: cover;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    align-items: center;
    padding: 0 76px 0 30px;
    position: relative;
    &>div{
      position: relative;
      z-index: 1;
    }
  }
  .com-logo{
    width: 116px;
    height: 70px;
    cursor: pointer;
  }
  .com-data-view{
    display: flex;
    flex: 1;
    flex-direction: row;
  }
  .com-data{
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #ffffff;
    padding-left: 12px;
    width: 400px;
    align-items: flex-start;
    p{
      margin: 0;
    }
    .com-name{
      font-size: 22px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .com-desc{
      font-size: 12px;
      line-height: 20px;
    }
  }
  .mask{
    position: absolute!important;;
    width: 100%;
    height: 100%;
    background: #000;
    left: 0;
    top: 0;
    z-index: 0;
    opacity: 0.55;
  }
  .call-com{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .call-btn{
    width: 130px;
    height: 36px;
    background: @main-color;
    border-radius: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #D6D6D6;
    cursor: pointer;
    font-size: 14px;
    margin-left: 6px;
    &.active{
      color: @a-color-active;
      background: #ffffff;
      .el-icon{
        color: @a-color-active;
      }
    }
  }
  .call-btn:hover{
    color: @a-color-active;
    background: #ffffff;
    .el-icon{
      color: @a-color-active;
    }
  }
  .el-icon{
    color: #ffffff;
    font-size: 16px;
    margin-right: 2px;
  }
  .com-data-right{
    margin-right: 26px;
    &>img{
      position: absolute;
      left: -60px;
      top: -32px;
    }
  }
  </style>
  